import { Component, createRef } from 'react';
import PropTypes from 'prop-types';

class Toggle extends Component {
	state = {
		on: this.props.open,
	}

	wrapper = createRef()

	escapeListener = event => {
		if (event.keyCode === 27) {
			this.toggle();
		}
	}

	clickListener = event => {
		const { wrapper } = this;
		const clickedOutside = !wrapper.current.contains(event.target);

		if (clickedOutside) {
			this.toggle();
		}
	}

	listen = () => {
		if (this.props.simple) return;
		window.addEventListener('click', this.clickListener);
		window.addEventListener('keyup', this.escapeListener);
	}

	dontListen = () => {
		if (this.props.simple) return;
		window.removeEventListener('click', this.clickListener);
		window.removeEventListener('keyup', this.escapeListener);
	}

	toggle = e => {
		if (e) {
			e.stopPropagation();
		}

		if (!this.state.on) {
			this.listen();
		} else {
			this.dontListen();
		}

		this.setState(prevState => ({
			on: !prevState.on
		}));
	}

	componentWillUnmount () {
		this.dontListen();
	}

	render () {
		const { on } = this.state;
		const { toggle, wrapper } = this;
		const { simple, children } = this.props;

		const passedProps = simple ? {
			on,
			toggle,
		} : {
			on,
			toggle,
			wrapper,
		};

		return children({ ...passedProps });
	}

	static propTypes = {
		children: PropTypes.func.isRequired,
		simple: PropTypes.bool,
		open: PropTypes.bool,
	}

	static defaultProps = {
		simple: false,
		open: false,
	}
}

export default Toggle;
